export default "__VITE_PUBLIC_ASSET__c8fb2743__"